<template>
    <div class="row">
        <div v-if="posStatus" :class="customerId ? 'col-md-9' : 'col-md-12'">
            <div class="card mb-3">
                <div class="card-body">
                    <Loading v-if="showLoading" />
                    <div class="row">
                        <form v-on:submit.prevent="checkCustomer" class="col-12">
                            <div class="row">
                                <div class="col-2">
                                    <label class="rdiobox"><input @change="changeCustomerType" v-model="customerType" name="customer-type" value="1" checked type="radio"><span>مشتری حقیقی</span></label>
                                </div>
                                <div class="col-2">
                                    <label class="rdiobox"><input @change="changeCustomerType" v-model="customerType" name="customer-type" value="2" type="radio"><span>مشتری حقوقی</span></label>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-4">
                                    <label for="national-code">{{ customerType == 1 ? 'کد ملی' : 'شناسه ملی' }}</label>
                                    <div class="input-group">
                                        <input class="form-control text-left" :maxlength="maxLength" id="national-code" type="tel" v-model="nationalCode">
                                        <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3" v-if="!customerDetails.company">
                                <div class="col-md-4" v-if="searchCustomer">
                                    <div class="form-group">
                                        <label>نام</label>
                                        <input type="text" class="form-control" v-model="customerDetails.name" :disabled="disabledInputs">
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="searchCustomer">
                                    <div class="form-group">
                                        <label>نام خانوادگی</label>
                                        <input type="text" class="form-control" v-model="customerDetails.lastName" :disabled="disabledInputs">
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="searchCustomer">
                                    <div class="form-group">
                                        <label>آدرس ایمیل</label>
                                        <input type="email" class="form-control ltr-input" v-model="customerDetails.email" :disabled="disabledInputs">
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="searchCustomer">
                                    <div class="form-group">
                                        <label>شماره همراه</label>
                                        <input type="tel" class="form-control ltr-input" v-model="customerDetails.phone" maxlength="11" :disabled="disabledInputs">
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="searchCustomer && !disabledInputs">
                                    <div class="form-group">
                                        <label>تاریخ تولد</label>
                                        <Datepicker locale="fa" :auto-submit="true" v-model="customerDetails.birthDate" :locale-config="{
                                            fa: {
                                                displayFormat: 'jYYYY/jMM/jDD',
                                                lang: {label: 'شمسی'}
                                            }
                                        }"/>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button class="btn btn-success mt-2" @click="registerCustomer" v-if="!findCustomer">ثبت نام کاربر</button>
                                </div>
                            </div>
                            <div class="row mt-3" v-else>
                                <div class="col-md-4" v-if="searchCustomer">
                                    <div class="form-group">
                                        <label>نام فارسی</label>
                                        <input type="text" class="form-control" v-model="customerDetails.companyNameFa" :disabled="disabledInputs">
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="searchCustomer">
                                    <div class="form-group">
                                        <label>نام انگلیسی</label>
                                        <input type="text" class="form-control text-left" v-model="customerDetails.companyNameEn" :disabled="disabledInputs">
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="searchCustomer">
                                    <div class="form-group">
                                        <label>شناسه ملی</label>
                                        <input type="text" class="form-control text-left" v-model="customerDetails.nationalId" :disabled="disabledInputs">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <hr class="mt-4" v-if="customerId">
                    <div class="row mt-4" v-if="customerId">
                        <div class="col-md-12">
                            <nav class="nav nav-tabs mb-3">
                                <a class="nav-link active" data-toggle="tab" href="#fizical-card">کارت هدیه آماده</a>
                                <a class="nav-link" data-toggle="tab" href="#visual-card">کارت هدیه مجازی</a>
                            </nav>
                            <div class="tab-content">
                                <div class="tab-pane active show" id="fizical-card">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label for="pan">پن کارت</label>
                                            <div class="input-group">
                                                <input class="form-control text-left" v-mask="'####-####-####-####'" id="pan" type="tel" v-model="pan">
                                                <span class="input-group-btn">
                                                    <button class="btn ripple btn-primary" type="button" @click="searchPan"><span class="input-group-btn"><i class="fa fa-search"></i></span></button>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-md-3" v-if="cardId">
                                            <div class="form-group">
                                                <label>انتخاب مبلغ شارژ</label>
                                                <select class="form-control mb-3" v-model="depositId">
                                                    <option value="61">مبلغ دلخواه</option>
                                                    <option v-for="(deposit,index) in depositsList" :key="index" :value="deposit.depositId">{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(deposit.depositValue) }} ریال</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-3" v-if="depositId == 61 && cardId">
                                            <div class="form-group">
                                                <label>مبلغ دلخواه (ریال)</label>
                                                <input type="tel" class="form-control ltr-input" v-model="optionalCredit" @change="checkOptionalCredit">
                                            </div>
                                        </div>
                                        <div class="col-md-2" v-if="cardId && depositId">
                                            <button class="btn btn-success btn-block" style="margin-top: 29px" @click="addToCard">ثبت و افزودن کارت</button>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center mt-3 mb-2">
                                        <div class="col-md-4 text-center">
                                            <img :src="`https://cardapi.sabinarya.com/${cardData.imageUrl}`" v-if="cardId">
                                            <p class="mt-3 mb-3" v-if="cardId">طرح : {{ cardData.title }}</p>
                                            <p class="mb-0" v-if="cardId">مبلغ : {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(cardData.price) }} ریال</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane" id="visual-card">
                                    <VisualCard :addToCard="visualAddToCard" :depositsList="depositsList" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="alert alert-warning mb-0">
                        <p class="mb-0">{{ posErrorMessage }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3" v-if="customerId">
            <div class="card custom-card card-body tx-white-8 bg-gray-800">
                <h6>سبد خرید</h6>
                <hr class="mb-4 mt-2">
                <p v-if="!basket.length" class="text-center mb-0">سبد خرید خالی است</p>
                <div v-else>
                    <div class="row mb-3" v-for="(card,index) in basket" :key="index">
                        <div class="col-md-4 pl-0">
                            <img :src="'https://cardapi.sabinarya.com' + card.imageUrl" class="w-100">
                        </div>
                        <div class="col-md-5">
                            <p class="mb-1">{{ card.title }}</p>
                            <p class="mb-1">تعداد: {{ card.itemsCount }}</p>
                            <p class="mb-1" v-if="card.deposit">مبلغ شارژ: {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(card.deposit) }}</p>
                        </div>
                        <div class="col-md-3">
                            <button class="btn ripple btn-danger btn-icon float-left" @click="removeCard(index)"><i class="fe fe-minus"></i></button>
                        </div>
                    </div>
                    <hr class="mt-2 mb-4">
                    <p>مبلغ کل : {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(totalPrice) }} ریال</p>
                    <button class="btn btn-success btn-block" @click="submit">تایید و ثبت سفارش</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const BASE_URL = 'http://localhost:8080';
import VisualCard from './Cards/VisualCard';

export default {
    name: 'CreatePishkhan',
    components: {VisualCard},
    data(){
        return {
            posStatus: true,
            posErrorMessage: '',
            customerType: 1,
            maxLength: 10,
            searchCustomer: false,
            showLoading: false,
            nationalCode: '',
            findCustomer: true,
            customerDetails: {},
            disabledInputs: false,
            pan: '',
            depositsList: [],
            depositId: 0,
            optionalCredit: 0,
            basket: [],
            totalPrice: 0,
            cardData: {},
            cardId: 0,
            customerId: 0,
            orderId: 0,
            paymentId: 0,
            amount: 0,
            serial: '',
            ADDONVER: null,
            ADDONPOSIP: null,
            ADDONPOSID: null,
            ADDONOFFICE: null
        }
    },
    methods: {
        getData(){
            this.$api.get('Cards/Deposits').then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    let deposits = data.result;
                    deposits.sort((a,b) => {
                        return a.depositValue - b.depositValue;
                    })
                    this.depositsList = deposits;
                }
            });
        },
        checkCustomer(){
            this.searchCustomer = false;
            const postedData = {
                customerType: this.customerType,
                nationalCode: this.nationalCode
            };
            if(this.customerType == 2)
                postedData['company'] = true;
            if((this.customerType == 1 && this.nationalCode.length != 10) || (this.customerType == 2 && this.nationalCode.length != 11))
                return false;
            this.showLoading = true;
            this.$api.post('epishkhan/customer/check',postedData).then(({data}) => {
                this.findCustomer = true;
                this.searchCustomer = true;
                if(!postedData['company'])
                    this.customerDetails = {
                        company: false,
                        ...data.result,
                        name: data.result.firstName,
                        phone: data.result.mobile
                    };
                else
                    this.customerDetails = {
                        company: true,
                        ...data.result
                    };
                this.customerId = data.result.customerId;
                this.disabledInputs = true;
            }).catch(({response}) => {
                this.customerDetails = {};
                this.searchCustomer = true;
                this.findCustomer = false;
                this.disabledInputs = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        registerCustomer(){
            this.showLoading = true;
            this.disabledInputs = true;
            const postedData = {
                name: this.customerDetails.firstName,
                lastName: this.customerDetails.lastName,
                phone: this.customerDetails.phone,
                nationalNo: this.customerDetails.nationalCode,
                email: this.customerDetails.email
            };
            this.$api.post('User/Register',postedData).then(({data}) => {
                if(data.status)
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'کاربر با موفقیت در سیستم ثبت شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                else
                    this.$swal({
                        title: 'خطا',
                        icon: 'error',
                        text: 'ثبت نام کاربر در سیستم ناموفق بود',
                        confirmButtonText: 'متوجه شدم'
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        },
        checkOptionalCredit(){
            if(this.optionalCredit > 20000000)
                this.optionalCredit = 20000000;
            else if(this.optionalCredit < 200000){
                this.optionalCredit = 0;
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'مبلغ شارژ نمی تواند کمتر از 200,000 ریال باشد',
                    confirmButtonText: 'متوجه شدم'
                });
            }
        },
        changeCustomerType(){
            this.customerDetails = {};
            this.legalCustomerDetails = {};
            this.maxLength = this.customerType == 1 ? 10 : 11;
            this.nationalCode = '';
            this.searchCustomer = false;
            this.findCustomer = true;
            this.customerId = 0;
        },
        removeCard(itemIndex){
            let basket = this.basket.filter((item,index) => index != itemIndex);
            this.basket = basket;
            this.calcTotalPrice();
        },
        calcTotalPrice(){
            let totalPrice = 0;
            let depositAmount = 0;
            let getDeposit;
            this.basket.map(item => {
                depositAmount = 0;
                if(item.depositId){
                    if(item.depositId == 61)
                        depositAmount += (parseInt(item.optionalCredit) * item.itemsCount);
                    else{
                        getDeposit = this.depositsList.filter(deposit => deposit.depositId == item.depositId)[0];
                        depositAmount += (parseInt(getDeposit.depositValue) * item.itemsCount);
                    }
                }
                totalPrice += (item.price * item.itemsCount) + depositAmount;
            });
            this.totalPrice = totalPrice;
        },
        addToCard(){
            let cardData = {
                ...this.cardData,
                optionalCredit: parseInt(this.cardData.optionalCredit),
                depositId: parseInt(this.depositId),
                itemsCount: parseInt(this.cardData.itemsCount),
                deposit: this.depositId == 61 ? this.optionalCredit : this.depositsList.filter(deposit => deposit.depositId == this.depositId)[0].depositValue.toString().replace(/,/g,'')
            };
            if(this.depositId == 61)
                cardData.optionalCredit = this.optionalCredit;
            else
                delete cardData.optionalCredit;
            this.basket.push(cardData);
            this.pan = '';
            this.cardData = {};
            this.cardId = 0;
            this.depositId = 0;
            this.optionalCredit = 0;
            this.calcTotalPrice();
            this.$swal({
                icon: 'success',
                title: 'تبریک !',
                text: 'کارت با موفقیت به سبد خرید افزوده شد'
            });
        },
        visualAddToCard(data){
            let cardData = {
                ...data,
                optionalCredit: parseInt(data.optionalCredit),
                depositId: parseInt(data.depositId),
                itemsCount: parseInt(data.itemsCount),
                deposit: data.depositId == 61 ? data.depositValue.toString().replace(/,/g,'') : this.depositsList.filter(deposit => deposit.depositId == data.depositId)[0].depositValue.toString().replace(/,/g,'')
            };
            if(data.depositId == 61)
                cardData.optionalCredit = data.depositId == 61 ? data.depositValue.toString().replace(/,/g,'') : this.depositsList.filter(deposit => deposit.depositId == data.depositId)[0].depositValue.toString().replace(/,/g,'');
            else
                delete cardData.optionalCredit;
            this.basket.push(cardData);
            this.pan = '';
            this.cardData = {};
            this.cardId = 0;
            this.depositId = 0;
            this.optionalCredit = 0;
            this.calcTotalPrice();
            this.$swal({
                icon: 'success',
                title: 'تبریک !',
                text: 'کارت با موفقیت به سبد خرید افزوده شد'
            });
        },
        searchPan(){
            this.showLoading = true;
            const postedData = {
                pan: this.pan.replace(/-/g,'')
            };
            this.$api.post('epishkhan/check',postedData).then(({data}) => {
                this.showLoading = false;
                if(data.status && data.result && !data.result.reserved){
                    let result = data.result;
                    this.cardData = {
                        cardId: result.cardId,
                        cardType: 1,
                        imageUrl: result.themeImage,
                        itemsCount: 1,
                        price: result.price,
                        title: result.title
                    };
                    this.cardId = result.cardId;
                }
            }).catch(({response}) => {
                this.showLoading = false;
                if(response){
                    const errors = response.data.errors;
                    console.log(errors);
                }
            });
        },
        submit(){
            this.showLoading = true;
            const postedData = {
                customerId: this.customerId,
                cardList: this.basket
            };
            this.$api.post('epishkhan/order/register',postedData).then(({data}) => {
                if(data.status){
                    this.orderId = data.result;
                    this.paypos(this.orderId);
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        receiveMessage(event){
            if(typeof event.data === 'string'){
                let dataArray = event.data.split('|');
                if(dataArray[1] === 'pg'){
                    switch(dataArray[2]){
                        case 'payres':
                            let result = dataArray[3].split('#');
                            let hloResStatus = (result[0].length === 8) ? true : false;
                            let payResStatus = result[0].slice(3, 5);
                            if (!hloResStatus && payResStatus === '00') {
                                let payResTrace = result[0].slice(5, 11);
                                let payResTermId = result[0].slice(11, 19);
                                let payResRRN = result[0].slice(19, 31);
                                let payResAmount = result[0].slice(31, 43);
                                this.amount = payResAmount;
                                let msg = '<div style="direction:rtl;text-align:right;">پرداخت موفق<br/>مبلغ پرداختی: <span style="font-size:24px;">' + new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(payResAmount) + '</span><br/>شناسه پرداخت: <span style="font-size:24px;">' + payResRRN + '</span></div>';
                                this.$swal({
                                    title: 'تبریک !',
                                    icon: 'success',
                                    html: msg,
                                    confirmButtonText: 'متوجه شدم'
                                });
                                this.successPayment(payResTrace,payResTermId,payResRRN,result[1]);
                                this.clearForm();
                            }else{
                                if(hloResStatus){
                                    let msg;
                                    if(result[0] != this.ADDONPOSID){
                                        msg = 'شناسه دستگاه کارتخوان با شناسه تنظیم شده در افزونه یکی نیست، لطفا شناسه ' + result[0] + ' را در تنظیمات افزونه وارد نمایید و سپس  مجددا سعی کنید.';
                                        this.$swal({
                                            title: 'خطا !',
                                            icon: 'error',
                                            html: msg,
                                            confirmButtonText: 'متوجه شدم'
                                        });
                                    }else{
                                        msg = 'دستگاه کارتخوان با شناسه ' + result[0] + ' متصل است.';
                                        this.$swal({
                                            title: 'توجه !',
                                            icon: 'info',
                                            html: msg,
                                            confirmButtonText: 'متوجه شدم'
                                        });
                                    }
                                }else{
                                    let msg = 'خطای در زمان پرداخت با کارتخوان رخ داده لطفا مجددا سعی نمایید. کد خطا: ' + payResStatus;
                                    this.$swal({
                                        title: 'خطا !',
                                        icon: 'error',
                                        html: msg,
                                        confirmButtonText: 'متوجه شدم'
                                    });
                                }
                            }
                            break;
                        case 'conerr':
                            let msg;
                            if(dataArray[3].indexOf('2152398862') != -1){
                                msg = "در صورتی که آدرس IP کارتخوان صحیح است، لطفا بررسی کنید که کارتخوان در حالت PC-POS باشد. برای قراردادن دستگاه در حالت PCPOS از منوی F3 استفاده نمایید. (<a href='http://iec24.com/images//pdf/IEC-PCPOS-Addons-Help_HO.pdf' > اطلاعات بیشتر</a>)";
                            }
                            this.$swal({
                                title: 'خطا !',
                                icon: 'error',
                                html: 'خطای برقراری ارتباط با کارتخوان<br/>' + dataArray[3] + msg,
                                confirmButtonText: 'متوجه شدم'
                            });
                            break;
                        case 'isalive':
                            let resArray = dataArray[3].split('#');
                            this.ADDONVER = resArray[0];
                            this.ADDONPOSIP = resArray[1];
                            this.ADDONPOSID = resArray[2];
                            this.ADDONOFFICE = resArray[3];
                            // $("#pos-info").attr('title',' نسخه افزونه: ' + this.ADDONVER + ' آدرس: ' + this.ADDONPOSIP + ' شناسه کارتخوان ' + this.ADDONPOSID + ' کد دفتر ' + this.ADDONOFFICE);
                            // $("#pos-infoNotify").attr('title',' نسخه افزونه: ' + this.ADDONVER + ' آدرس: ' + this.ADDONPOSIP + ' شناسه کارتخوان ' + this.ADDONPOSID + ' کد دفتر ' + this.ADDONOFFICE);
                            window.postMessage('pg|cs|pay|HELLO#0',BASE_URL);
                            break;
                        case 'die':
                            window.postMessage('pg|cs|pay|EXIT#0',BASE_URL);
                            break;
                        default:
                            console.log('توجه',dataArray[3]);
                    }
                }
            }
        },
        successPayment(posTrace,posTermId,posRRN,refId){
            const postedData = {
                orderId: parseInt(this.orderId),
                amount: parseInt(this.amount.toString().replace(/,/g,'')),
                serial: this.serial,
                refNum: refId,
                posTrace,
                posTerminal: posTermId,
                paymentId: this.paymentId,
                posRrn: posRRN
            };
            this.$api.post('epishkhan/Payment/Pos/verify',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک !',
                        icon: 'success',
                        html: 'پرداخت شما با موفقیت انجام و سفارش شما ثبت شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                }else
                    this.$swal({
                        title: 'خطا !',
                        icon: 'error',
                        html: 'خطایی رخ داده است',
                        confirmButtonText: 'متوجه شدم'
                    });
            });
        },
        paytax(val,ref){
            window.postMessage('pg|cs|pay|' + val + '#' + ref,BASE_URL);
        },
        paypos(orderId){
            const postedData = {
                orderId,
                paymentType: 1
            };
            this.$api.post('epishkhan/Payment/Pos/Request',postedData).then(({data}) => {
                if(data.status){
                    this.serial = data.result.serial;
                    this.paymentId = data.result.paymentId;
                    this.paytax(data.result.posToken,data.result.orderId);
                }else{
                    this.$swal({
                        title: 'خطا !',
                        icon: 'error',
                        html: 'خطا در ثبت سفارش',
                        confirmButtonText: 'متوجه شدم'
                    });
                }
            }).catch(() => {
                this.$swal({
                    title: 'خطا !',
                    icon: 'error',
                    html: 'خطا در برقراری ارتباط با سرور',
                    confirmButtonText: 'متوجه شدم'
                });
            });
        },
        checkPosStatus(){
            // this.$api.post('epishkhan/Payment/Pos/Status').then(({data}) => {
            //     if(!data.result && !data.status)
            //         this.posStatus = false;
            // }).catch(data => {
            //     this.posErrorMessage = data.response.message;
            // });
        }
    },
    created(){
        this.checkPosStatus();
        this.getData();
        window.addEventListener('message',this.receiveMessage,false);
    }
}
</script>